export const COLUMNS = [
  { sortKey: 'site', name: 'Site Name', width: '8%' },
  { sortKey: 'country', name: 'Country' },
  { sortKey: 'org', name: 'Org' },
  { sortKey: 'subOrg', name: 'Sub-Org', width: '8%' },
  { sortKey: 'buildingType', name: 'Building Type', width: '10%' },
  { sortKey: 'region', name: 'Region' },
  { sortKey: 'isActive', name: 'Is Active?', width: '8%' },
  { sortKey: 'description', name: 'Description', width: '10%' },
  { sortKey: 'headcount', name: 'Average Headcount' },
  { sortKey: 'tldHeadcount', name: 'Allowed TLD Jobs' },
  { sortKey: 'siteCoLocations', name: 'Co-located Sites' },
  {
    sortKey: 'participatingInDecisionHubPilot',
    name: 'Is participating in Decision Hub pilot?',
  },
  {
    sortKey: 'atozNotificationsEnabled',
    name: 'Is participating in AtoZ Notifications pilot?',
  },
  {
    sortKey: 'jobModificationsEnabled',
    name: 'Is participating in Job Modifications pilot?',
  },
  {
    sortKey: 'nonPhysicalLimitationsEnabled',
    name: 'Is participating in Non Physical Limitations pilot?',
  },
  { name: 'Edit' },
];
